import { Link } from 'react-router-dom';
import { categories, aboutInfo } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">芒果视频</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              资源丰富，播放流畅，免费高清。芒果视频致力于为用户提供最优质的观影体验，是蜜桃视频与糖豆视频之外的最佳选择。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快捷导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/recommend" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">热门推荐</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-base"></i>
                <span>{aboutInfo.contact.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-base"></i>
                <span>{aboutInfo.contact.wechat}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-weibo-line text-base"></i>
                <span>{aboutInfo.contact.weibo}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 芒果视频. 保留所有权利.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}